import React from 'react';
import cn from 'classnames';
import { CdnIcon } from '@shared/ui';
import CdnImage from '../../../../../CdnImage/CdnImage';
import { useTheme, useMergeClasses } from '../../../../../theme';
import { Tooltip } from '../../../../../BaseComponents';
const Restrictions = ({ classes, variant = 'forbidden', title, subtitle, img, list }) => {
    const { Restrictions: defaultClasses } = useTheme('Shared');
    const css = useMergeClasses(defaultClasses, classes);
    const showList = !!list && list.length > 0;
    return (React.createElement("div", { className: cn(css.root, {
            [css.forbidden]: variant === 'forbidden',
            [css.allowed]: variant === 'allowed'
        }) },
        React.createElement("div", { className: css.header },
            React.createElement(CdnIcon, { className: css.header__icon, icon: variant === 'forbidden' ? 'Info/Cancel' : 'Info/Item Icluded' }),
            React.createElement("div", { className: css.title__wrapper },
                React.createElement("div", { className: css.title }, title),
                !!subtitle && React.createElement("div", { className: css.subtitle }, subtitle))),
        React.createElement("div", { className: css.line }),
        React.createElement("div", { className: css.content },
            !!img && React.createElement(CdnImage, { className: css.image, path: img }),
            showList && (React.createElement("div", { className: css.list }, list.map((item, index) => (React.createElement("div", { key: index, className: css.item },
                React.createElement("div", { className: css.item__title }, item.title),
                !!item.description && (React.createElement(Tooltip, { title: item.description, titleClassName: css.item__description, tooltipClassName: css.item__tooltip, arrowClassName: css.item__tooltip_arrow, enterTouchDelay: 0 },
                    React.createElement("div", null,
                        React.createElement(CdnIcon, { className: css.item__icon, icon: "Info/Question" }))))))))))));
};
export default Restrictions;
